import usePermissionsMode from './usePermissionsMode';
import { usePermissionCheck } from './useHasPermission';

function WithPermissions({
  children,
  permission,
  rbacPermission,
  resourceType,
  resourceId,
  fallback = null
}) {
  const { isRbacEnabled } = usePermissionsMode();
  const { allowed, loading } = usePermissionCheck({
    permission,
    rbacPermission,
    resourceType,
    resourceId
  });

  if (isRbacEnabled && loading) {
    return <>{fallback}</>;
  }

  return allowed ? <>{children}</> : <>{fallback}</>;
}

export default WithPermissions;
